"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeInCache = exports.loadFromCache = void 0;
var getHoursSinceCached = function getHoursSinceCached(cachedAt) {
  return Math.abs(new Date().getTime() - cachedAt) / 3600000;
};
var localStorageAccessDenied = function localStorageAccessDenied() {
  return localStorage === null;
};
var loadFromCache = function loadFromCache(key) {
  var CacheTimeoutInHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (localStorageAccessDenied()) {
    return false;
  }
  var cachedData = localStorage.getItem(key);
  if (!cachedData) {
    return false;
  }
  var _JSON$parse = JSON.parse(cachedData),
    cachedAt = _JSON$parse.cachedAt,
    data = _JSON$parse.data;
  var cacheExpired = getHoursSinceCached(cachedAt) > CacheTimeoutInHours;
  return cacheExpired ? false : data;
};
exports.loadFromCache = loadFromCache;
var storeInCache = function storeInCache(key, data) {
  if (localStorageAccessDenied()) {
    return;
  }
  var rightNow = new Date().getTime();
  localStorage.setItem(key, JSON.stringify({
    data: data,
    cachedAt: rightNow
  }));
};
exports.storeInCache = storeInCache;